import { render, staticRenderFns } from "./colorcircle.vue?vue&type=template&id=66a766f9"
import script from "./colorcircle.vue?vue&type=script&lang=js"
export * from "./colorcircle.vue?vue&type=script&lang=js"
import style0 from "./colorcircle.vue?vue&type=style&index=0&id=66a766f9&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a766f9')) {
      api.createRecord('66a766f9', component.options)
    } else {
      api.reload('66a766f9', component.options)
    }
    module.hot.accept("./colorcircle.vue?vue&type=template&id=66a766f9", function () {
      api.rerender('66a766f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/colorworld/assets/frontend/components/colorcircle.vue"
export default component.exports